import Ajax from "Utils/ajax";
 export const leaveMatrix = () => Ajax.post('hr/leaveMatrix'); 
export const applyForSL = (data) => Ajax.post('hr/applyForSL',data);
export const leaveReason = () => Ajax.post('hr/leaveReason'); 
export const shortLeaveList = (data) => Ajax.post('hr/shortLeaveList',data); 
export const removeSLRequest = (data) => Ajax.post('hr/removeSLRequest',data); 
export const getUserNameById = (data) => Ajax.post('hr/getUserNameById',data);
export const changeLeaveStatus = (data) => Ajax.post('hr/changeLeaveStatus',data);